export class AssignConstructor {
    constructor(params: any) {
        Object.assign(this, params)
    }
}
